import React, { Fragment, useState, useEffect } from 'react';
import { Box, List, ListItem, Typography, Divider } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import {
  getAvailableSortOptionsForStep,
  isImplementationStep,
} from '../../../../../../Utils/Steps';
import { SteppablePostType } from '../../../../../../Utils/Types/Steps';
import PostListItem from '../../../../../DesignSystem/PostListItem';
import ButtonLoadMore from '../../../../ButtonLoadMore';
import SortBy from '../../../../../Comments/Show/SortBy';
import usePostsInfiniteQuery from '../../../../../../Hooks/usePostsInfiniteQuery';
import { getFiltersValues } from '../../../../../../Utils/filters';
import { useSearchParams } from 'react-router-dom';

function TabPostsList({
  parent,
  status,
  iVotedFor,
  stepTab,
  space,
  emptyState,
}: {
  parent: any;
  status: string;
  iVotedFor: boolean;
  stepTab: any;
  space: any;
  emptyState: any;
}) {
  const sortingFields = getAvailableSortOptionsForStep(parent.type as SteppablePostType, stepTab);
  const [searchParams] = useSearchParams();
  const search = searchParams.get('q') || '';
  const defaultSortValue = sortingFields[0].value;
  const [sortBy, setSortBy] = useState(defaultSortValue);

  useEffect(() => {
    setSortBy(defaultSortValue);
  }, [stepTab.step_type]);

  const {
    postsCount,
    pages,
    paging,
    isFetching,
    fetchNextPage: loadPosts,
  } = usePostsInfiniteQuery(['post-children', stepTab.step_type], {
    space,
    status,
    parentId: parent.id,
    limit: 10,
    sort: sortBy,
    search,
    iVotedFor,
    extraParams: {
      filter: {
        ...getFiltersValues(),
      },
    },
  });

  const posts = pages.flatMap((page: any) => page.data.data);

  const renderList = () => {
    if (isFetching && !posts.length) {
      return <div style={{ height: 800 }} />;
    }

    return (
      <List disablePadding>
        {posts.map((post: any) => (
          <Fragment key={stepTab.step_type + post.id}>
            <Divider component="li" />
            <ListItem sx={{ paddingY: 0 }} disableGutters>
              <PostListItem
                post={post}
                currentStep={post.included.source?.current_step}
                stepTab={stepTab}
                trackingProps={{ category: 'Post List', name: 'Idea - Card Click' }}
                hideButtons={false}
                parent={parent}
                space={space}
                newTab
              />
            </ListItem>
          </Fragment>
        ))}
      </List>
    );
  };

  return (
    <>
      {postsCount > 0 ? (
        <>
          <Box
            sx={{
              mb: 3,
              px: 2,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}
          >
            <Typography
              variant="body1"
              component="p"
              sx={{
                fontWeight: 'bold',
              }}
            >
              <FormattedMessage
                id="POSTS.CONSULTATIONS.FEED_TITLE.IDEAS_COUNT"
                values={{ itemCount: postsCount }}
              />
            </Typography>

            <SortBy items={sortingFields} value={sortBy || defaultSortValue} onChange={setSortBy} />
          </Box>

          {renderList()}

          {paging?.page && paging.page < paging.total_pages && (
            <>
              <Divider />

              <Box
                sx={{
                  mt: 3,
                  pb: 3,
                }}
              >
                <ButtonLoadMore
                  onClick={loadPosts}
                  paging={paging}
                  isFetching={isFetching}
                  variant="text"
                />
              </Box>
            </>
          )}
        </>
      ) : (
        !isImplementationStep(stepTab.step_type) && emptyState
      )}
    </>
  );
}

export default TabPostsList;
